import { IconButton, Tooltip } from '@mui/material';
import TableRow from '@mui/material/TableRow';
import { useQueryClient } from '@tanstack/react-query';
import useApiServices from 'src/api/useApiServices';
import AppButton from 'src/components/appComponents/AppButton';
import AppTableCell from 'src/components/appComponents/table/AppTableCell';
import { ConfirmDialog } from 'src/components/custom-dialog';
import Iconify from 'src/components/iconify';
import Label from 'src/components/label';
import { ASSETS_API_AI } from 'src/config-global';
import { useBoolean } from 'src/hooks/use-boolean';
import { IJobStatusDto } from 'src/types/JobStatus';

type Props = {
  row: IJobStatusDto;
};

export default function JobStatusTableRow({ row }: Props) {
  const confirm = useBoolean();
  const { usePostApi } = useApiServices();
  const queryClient = useQueryClient();

  const { mutate: mutateCancelTask, isLoading: isLoadingCancelTask } = usePostApi({
    url: `${ASSETS_API_AI}youtube-search/task/${row?.task_id}/cancel`,
    onSuccess: () => {
      confirm.onFalse();
      queryClient.refetchQueries([`${ASSETS_API_AI}youtube-search/tasks`]);
    },
  });

  return (
    <>
      <TableRow hover>
        <AppTableCell value={row?.task_id} />
        <AppTableCell
          value={
            <Label
              color={
                row?.status === 'completed'
                  ? 'success'
                  : row?.status === 'running'
                    ? 'warning'
                    : 'error'
              }
            >
              {row?.status}
            </Label>
          }
        />
        <AppTableCell value={new Date(row?.start_date)?.toLocaleDateString()} />
        <AppTableCell value={new Date(row?.end_date)?.toLocaleDateString()} />
        <AppTableCell
          value={
            <Tooltip title="Delete" placement="bottom" arrow>
              <IconButton onClick={confirm.onTrue}>
                <Iconify icon="solar:trash-bin-trash-bold" width="24" height="24" color="#51C1CF" />
              </IconButton>
            </Tooltip>
          }
        />
      </TableRow>

      {/* Delete Dialog */}
      <ConfirmDialog
        open={confirm.value}
        onClose={confirm.onFalse}
        content="Do you really want to delete this role?"
        action={
          <AppButton
            label="Delete"
            color="error"
            isLoading={isLoadingCancelTask}
            onClick={() => mutateCancelTask({ task_id: row?.task_id })}
          />
        }
      />
    </>
  );
}
